module.exports = __webpack_public_path__ + "static/media/PromotionsIcon.2b1e259e.png";